import { SET_APP_DATA, SET_APP_LOADING } from "src/redux/constants";
import { setCurrentUser } from "src/redux/user/actions";

export const getAppData = (payload) => async (dispatch) => {
  let appData = {};
  const token = localStorage.getItem("userToken");
  // setApiHeaders({ uid: null });
  if (token) {
    await dispatch(setCurrentUser(token))
      .then(async (user) => {
        dispatch({
          type: SET_APP_DATA,
          payload: { ...appData },
        });
      })
      .catch((error) => {});
  }
  dispatch({
    type: SET_APP_LOADING,
    payload: false,
  });
};

export const setAppLoading = (payload) => async (dispatch) => {
  dispatch({
    type: SET_APP_LOADING,
    payload,
  });
};
